import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const img = (name) =>
  name && name.includes("/")
    ? `${process.env.REACT_APP_BACKEND_URL}/api/images/file/${name}`
    : `${process.env.REACT_APP_BACKEND_URL}/api/images/${name}`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) => `$${Number(n).toFixed(0)}`;
